//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as ebookHighLightsAction from './actions';
import { logToSentry } from "utils/networkErrorUtils";

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create log ----------------


export const handleNonNativeEbookCreateHighlights = (data) => async dispatch =>{
	try {
		const highlights = await apis.post('non_native_ebook_highlight', `/create_non_native_highlight`, {
			body: { ...data }
		});
		if (highlights && highlights.id) {
			dispatch(ebookHighLightsAction.createOrUpdateEbookHighlight(highlights))
		}
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'creating non native ebook highlights',
                error,
                module: 'EBOOK_NON_NATIVE_IMAGE_HIGHLIGHTER',
                operation: 'CREATE_NON_NATIVE_EBOOK_HIGHLIGHTER'
            });
		}
		return error;
	}
};
export const handleNonNativeEbookListHighlights =  (book_id) => async dispatch =>{
	dispatch(ebookHighLightsAction.clearEbookHighlighter());
	try {
		const highlights = await apis.post('non_native_ebook_highlight', `/list_non_native_ebook_highlights`, {
			body: { book_id }
		});
		if (Array.isArray(highlights)) {
			dispatch(ebookHighLightsAction.setEbookHighlight(highlights))
		}
		return highlights;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'listing non native ebook highlights',
                error,
                module: 'EBOOK_NON_NATIVE_IMAGE_HIGHLIGHTER',
                operation: 'LIST_NON_NATIVE_EBOOK_HIGHLIGHTER'
            });
		}
		return error;
	}
};

export const handleGenerateDefinitionAI = (data) => async (dispatch) => {
	try {
		const result = await apis.post('non_native_ebook_highlight', `/ai/generate/definition`, {
			body: data
		});
		return result;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
				message: 'generating definition with AI',
				error,
				module: 'EBOOK_NON_NATIVE_IMAGE_HIGHLIGHTER',
				operation: 'GENERATE_DEFINITION_AI'
			});
		}
		return error;
	}
};

